import { defineStyleConfig as r } from "@chakra-ui/react";
import { ThemeColorVariable as o, ThemeBorderVariable as e } from "../../theme-types.js";
const a = {
  display: "flex",
  justifyContent: "space-between",
  border: `${e.XSmall} transparent`,
  '&[aria-disabled="true"]': {
    borderColor: "transparent",
    backgroundColor: o.SurfaceDisabled,
    cursor: "not-allowed"
  },
  '&[aria-readonly="true"]': {
    borderColor: "transparent",
    backgroundColor: o.SurfaceDisabled
  }
}, n = {
  outline: {
    background: o.Surface,
    color: o.OnSurface,
    borderColor: o.OnSurfaceBorder,
    "@media(hover: hover)": {
      '&:hover:not(:focus-within):not([aria-disabled="true"]):not([aria-readonly="true"])': {
        borderColor: o.OnSurface
      }
    }
  },
  ghost: {
    background: "none",
    color: o.OnSurface,
    '&:not([aria-disabled="true"]):not([aria-readonly="true"]) .combobox-dropdown-icon': {
      opacity: 0
    },
    ":focus-within": {
      ".combobox-dropdown-icon": {
        opacity: 1
      }
    },
    "@media(hover: hover)": {
      "&:hover:not(:focus-within)": {
        backgroundColor: o.SurfaceDisabled,
        ".combobox-dropdown-icon": {
          opacity: 1
        }
      }
    }
  }
}, i = {
  xs: {
    minHeight: "24px"
  },
  sm: {
    minHeight: "32px"
  },
  md: {
    minHeight: "40px"
  },
  lg: {
    minHeight: "48px"
  },
  xl: {
    minHeight: "56px"
  }
}, c = r({
  baseStyle: a,
  sizes: i,
  variants: n
});
export {
  c as comboboxConfig
};
